import React from "react";
import "./Footer.css";
const Footer = ({ style }) => {
  return (
    <div className="client__dashboard_footer" style={style}>
      © Serene Tax 2023
    </div>
  );
};

export default Footer;
